import React from 'react';

/**
 * Catches render-time errors anywhere in the wrapped tree and shows a
 * friendly fallback instead of crashing the whole app to a blank white screen.
 *
 * React requires error boundaries to be class components.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    // Render the fallback UI on the next render.
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Log for debugging; replace with a real reporting service if desired.
    console.error('Unhandled UI error:', error, info);
  }

  handleReload = () => {
    // Reset and let the route re-render; full reload as a safety net.
    this.setState({ hasError: false });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            maxWidth: 480,
            margin: '80px auto',
            padding: '24px',
            textAlign: 'center',
            fontFamily: 'inherit',
          }}
        >
          <h2>Something went wrong</h2>
          <p>
            We hit an unexpected error while loading this page. Please try
            again — if the problem persists, contact support.
          </p>
          <button
            type="button"
            onClick={this.handleReload}
            style={{
              marginTop: 12,
              padding: '10px 20px',
              cursor: 'pointer',
            }}
          >
            Reload page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
